class SectionText extends HTMLElement {
  constructor() {
    super();
    this.data = scrapeSectionData(this);
    this.section = this.querySelector("[data-text]");
    this.sectionHeading = this.querySelector("[data-text-heading]");
    this.initFunction();
  }

  renderText = () => {
    let words = this.data?.sectionHeading?.split(" ");

    this.sectionHeading.innerHTML = words
      .map((word) => `<span class="mask">${word}</span>`)
      .join("");

    if (!('ScrollTimeline' in window)) {
      window.loadLegacyAnimations.then(() => {
        window.legacyAnimations.refresh("swipe");
      });
    }
  };

  initFunction() {
    if (!this.classList.contains("animate")) return false;
    let timeout = false;
    this.renderText();

    let lastWidth = window.innerWidth;
    window.addEventListener("resize", () => {
      // Only update on width change to avoid unnecessary recalcs
      // on mobile when menu bar toggles
      if (window.innerWidth === lastWidth) return;

      clearTimeout(timeout);
      timeout = setTimeout(this.renderText, 500);
    });
  }
}

if (!customElements.get("section-text")) {
  customElements.define("section-text", SectionText);
}
